import { BifrostClient, WebStorageAdapter } from '@Lar21/bifrost-client'
import Cookies from 'js-cookie'
import { FiltradorDeErros } from 'src/erros'

const BIFROST_URL_LOCAL = 'http://localhost:8010'

function obterBifrostUrl (): string {
  if (process.env.VUE_APP_K8s) {
    const namespace = obterNamespace()
    return `${window.location.origin}${namespace}/bifrost`
  }

  return process.env.VUE_APP_BIFROST_URL || BIFROST_URL_LOCAL
}

function obterNamespace (): string {
  let namespace = window.location.pathname
  namespace = namespace[namespace.length - 1] === '/' ? namespace.slice(0, namespace.length - 1) : namespace
  namespace = namespace.split('/new-front')[0]
  return namespace
}

function normalizarToken (token?: string): string | null {
  const tokenNormalizado = token?.trim()

  if (!tokenNormalizado || tokenNormalizado === 'null' || tokenNormalizado === 'undefined') {
    return null
  }

  return tokenNormalizado
}

const bifrostClient = new BifrostClient({
  baseUrl: obterBifrostUrl(),
  platform: 'web',
  storage: new WebStorageAdapter(),
  getAuthToken: async () => {
    const token = normalizarToken(Cookies.get('Authorization')) || normalizarToken(Cookies.get('accessToken'))
    if (!token) {
      throw new Error('Token de autenticacao nao encontrado')
    }
    return token.replace(/^Bearer\s+/i, '')
  }
})

const TTL_MS = 5 * 60 * 1000 // 5 minutos
let secretsCarregados: Record<string, string> | null = null
let ultimoCarregamento = 0

let refreshEmAndamento = false

function cacheExpirado (): boolean {
  return Date.now() - ultimoCarregamento > TTL_MS
}

function refreshEmBackground (): void {
  if (refreshEmAndamento) return
  refreshEmAndamento = true
  bifrostClient.getOrFetchSecrets()
    .then((secrets: Record<string, string> | null) => {
      secretsCarregados = secrets ?? secretsCarregados
      ultimoCarregamento = Date.now()
    })
    .catch((erro: unknown) => {
      FiltradorDeErros.capturarErro(erro as Error)
    })
    .finally(() => {
      refreshEmAndamento = false
    })
}

export async function carregarSecrets (): Promise<Record<string, string>> {
  try {
    secretsCarregados = await bifrostClient.getOrFetchSecrets()
    ultimoCarregamento = Date.now()
    return secretsCarregados ?? {}
  } catch (erro) {
    FiltradorDeErros.capturarErro(erro as Error)
    return {}
  }
}

export function obterSecret (chave: string): string {
  if (!secretsCarregados) {
    return ''
  }
  if (cacheExpirado()) {
    refreshEmBackground()
  }
  return secretsCarregados[chave] || ''
}

export async function obterSecretAsync (chave: string): Promise<string> {
  if (!secretsCarregados || cacheExpirado()) {
    await carregarSecrets()
  }
  return obterSecret(chave)
}

export async function refreshSecretsBifrost (): Promise<Record<string, string>> {
  try {
    secretsCarregados = await bifrostClient.refreshSecrets()
    ultimoCarregamento = Date.now()
    return secretsCarregados ?? {}
  } catch (erro) {
    FiltradorDeErros.capturarErro(erro as Error)
    return {}
  }
}

export async function limparCacheBifrost (): Promise<void> {
  secretsCarregados = null
  ultimoCarregamento = 0
  await bifrostClient.clearCache()
}

export function secretsEstaoCarregados (): boolean {
  return secretsCarregados !== null && !cacheExpirado()
}
